import React from "react";
import {
  IComboBox,
  IComboBoxOption,
  TextField,
} from "@fluentui/react";
import { IOpenPanel } from "../../../../interfaces/base/IPanel";
import { useLugarMovilizacionHorario } from "./useLugarMovilizacionHorario";
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { ProgressBarLoading } from "../../../../components/ProgressBarLoading/ProgressBarLoading";
import { UseComboGuardiaProgramacionHorarios } from "../../../../hooks/combos/UseComboGuardiaProgramacionHorarios";
import { ComboBoxBase } from "../../../../components/comboBoxComponent/ComboBoxBase";
import { PanelGenerico } from "../../../../components/Generic/PanelGenerico";
import { IItemComboBaseDTO } from "../../../../interfaces/base/IBase";
import { IListarLugarMovilizacionHorarioDto } from "../../../../interfaces/ILugarMovilizacionHorario";
import { UseUbicacion } from "../../../configuraciones/ubicacion/UseUbicacion";
import { Field, Textarea } from "@fluentui/react-components";

const PanelCrearLugarMovilizacionHorario = (props: IOpenPanel & {
  dataEdit: IListarLugarMovilizacionHorarioDto;
  setDataEdit: (value: IListarLugarMovilizacionHorarioDto) => void;
}) => {
  const {
    command,
    setCommand,
    postCrearLugarMovilizacionHorario,
    putEditarLugarMovilizacionHorario,
    loading,
    setLoading,
    disableForm,
    cerrarPanel,
    mensaje,
    setMensaje,
    status,
    buttonSalir,
  } = useLugarMovilizacionHorario(props);

  const {
    dataComboGuardiaProgramacion,
    onClickComboGuardiaProgramacion,
    _onkeyUpSearchGuardiaProgramacion,
    comboBoxRefGuardiaProgramacion,
    filter,
  } = UseComboGuardiaProgramacionHorarios(props.isOpen);

  const { items } = UseUbicacion(true);

  const actividadesOptions: IItemComboBaseDTO[] = [
    { key: "1", text: "SUBIDA" },
    { key: "2", text: "BAJADA" },
  ];

  const onChangeText = (type: string, newValue?: string) => {
    if (newValue) {
      switch (type) {
        case "horarioEmbarque":
          setCommand({
            ...command,
            horarioEmbarque: newValue,
          });
          break;
        case "horarioSalida":
          setCommand({
            ...command,
            horarioSalida: newValue,
          });
          break;
        case "comentario":
          setCommand({
            ...command,
            comentario: newValue,
          });
          break;
        default:
          break;
      }
    }
  };

  const onChangeCombo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    type?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        switch (type) {
          case "lugar":
            setCommand({
              ...command,
              lugarMovilizacionId: option.key.toString(),
            });
            break;
          case "guardia":
            setCommand({
              ...command,
              guardiaProgramacionId: option.key?.toString(),
            });
            break;
          case "actividad":
            setCommand({
              ...command,
              actividad: +option.key,
            });
            break;
          default:
            break;
        }
      }
    }
  };

  return (
    <PanelGenerico
      isOpen={props.isOpen}
      onDismiss={cerrarPanel}
      isOnRenderHeader
      iconHeaderName="TemporaryUser"
      title={`${props.dataEdit?.lugarMovilizacionHorarioId ? "Editar" : "Registro de"} Horarios por Lugar de Movilización`}
      subTitle={`Complete el formulario para ${props.dataEdit?.lugarMovilizacionHorarioId ? "editar" : "registrar"} un horario por lugar de movilización`}
      textRegister={props.dataEdit?.lugarMovilizacionHorarioId ? "Editar" : "Registrar"}
      registrar={props.dataEdit?.lugarMovilizacionHorarioId ? putEditarLugarMovilizacionHorario : postCrearLugarMovilizacionHorario}
      disabledRegister={disableForm}
      disabledIconHeader={false}
    >
      <div className="ms-Grid" dir="ltr">
        {mensaje && (
          <MessageBarResponse
            objetoResponse={{ codigo: status, mensaje: mensaje }}
            close={true}
          />
        )}
        {loading && <ProgressBarLoading></ProgressBarLoading>}

        {!loading && !mensaje && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridGap: "10px",
              paddingTop: "10px",
            }}
          >
            <TextField
              type="time"
              label="Horario Embarque"
              name="horarioEmbarque"
              placeholder="Horario de Embarque"
              value={command.horarioEmbarque ?? ""}
              onChange={(e, v) => onChangeText("horarioEmbarque", v)}
              autoComplete="off"
            />

            <TextField
              type="time"
              label="Horario Salida"
              name="horarioSalida"
              placeholder="Horario de Salida"
              value={command.horarioSalida ?? ""}
              onChange={(e, v) => onChangeText("horarioSalida", v)}
              autoComplete="off"
            />

            <ComboBoxBase
              title="Actividad"
              text={
                actividadesOptions.find((x) => +x.key === command.actividad)
                  ?.text
              }
              required
              options={actividadesOptions}
              selectedKey={command.actividad}
              onChange={(e: React.FormEvent<IComboBox>, option) => {
                onChangeCombo(e, option, "actividad");
              }}
            />

            <TextField
              label="Comentario"
              name="comentario"
              multiline
              placeholder="Comentario"
              value={command.comentario?.toString()}
              onChange={(e, v) => onChangeText("comentario", v)}
              autoComplete="off"
            />

            <ComboBoxBase
              title="Lugar de Movilización"
              placeholder="Lugar de Movilización"
              required
              text={
                items.find((x) => x.lugarMovilizacionId === command.lugarMovilizacionId)
                  ?.nombre
              }
              options={items.map((x) => ({
                key: x.lugarMovilizacionId,
                text: x.nombre,
              }))}
              selectedKey={command.guardiaProgramacionId}
              onChange={(e: React.FormEvent<IComboBox>, option) => {
                onChangeCombo(e, option, "lugar");
              }}
              description={true}
            />
            <ComboBoxBase
              title="Guardia"
              placeholder="Guardia"
              componentRef={comboBoxRefGuardiaProgramacion}
              KeyUp={_onkeyUpSearchGuardiaProgramacion}
              onClick={onClickComboGuardiaProgramacion}
              options={dataComboGuardiaProgramacion}
              selectedKey={command.guardiaProgramacionId}
              onChange={(e: React.FormEvent<IComboBox>, option) => {
                onChangeCombo(e, option, "guardia");
              }}
              description={true}
            />
          </div>
        )}
      </div>
    </PanelGenerico>
  );
};

export { PanelCrearLugarMovilizacionHorario };
